import { MONTHS_FR } from './locale';

export function fmtEUR(n, { sign = false } = {}) {
  const v = Number(n) || 0;
  const abs = Math.abs(v).toFixed(2).replace('.', ',');
  if (!sign) return `${abs} €`;
  const prefix = v < 0 ? '− ' : v > 0 ? '+ ' : '';
  return `${prefix}${abs} €`;
}

function toDate(input) {
  return input instanceof Date ? input : new Date(input);
}

export function toIsoDay(input) {
  const d = toDate(input);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function fmtDateShort(input) {
  const d = toDate(input);
  const mois = MONTHS_FR[d.getMonth()].slice(0, 3).toLowerCase();
  return `${String(d.getDate()).padStart(2, '0')} ${mois}`;
}

export function fmtDateLong(input) {
  const d = toDate(input);
  const mois = MONTHS_FR[d.getMonth()].toLowerCase();
  return `${d.getDate()} ${mois}`;
}

export function dayOfWeekShort(input) {
  const d = toDate(input);
  return ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'][d.getDay()];
}

export function groupByDate(txs) {
  const g = {};
  txs.forEach((t) => {
    const key = toIsoDay(t.date);
    (g[key] = g[key] || []).push(t);
  });
  return Object.entries(g).sort((a, b) => b[0].localeCompare(a[0]));
}

export function deriveUserDisplay(email) {
  if (!email) return { firstName: '', initials: '' };
  const local = String(email).split('@')[0] || '';
  const cleaned = local.replace(/[._-]+/g, ' ').trim();
  const parts = cleaned.split(/\s+/).filter(Boolean);
  const firstName = parts[0]
    ? parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase()
    : '';
  const initials = (parts.length >= 2
    ? parts[0].charAt(0) + parts[1].charAt(0)
    : (parts[0] || '').slice(0, 2)
  ).toUpperCase();
  return { firstName, initials };
}

export function greetingPrefix(date = new Date()) {
  const h = date.getHours();
  if (h < 6) return 'Bonne nuit';
  if (h < 12) return 'Bonjour';
  if (h < 18) return 'Bon après-midi';
  return 'Bonsoir';
}
